import { ComponentProps, Fragment } from 'react';

import { useTheme } from '../../styles';
import { Icon } from '../Icon';
import { Label } from '../Text';
import { View } from '../View';

/**
 * Displays potential outcomes for a given practice and whether or not they were achieved.
 */
export const PracticeOutcome = ({
  outcomes,
}: {
  outcomes: Array<{ icon: ComponentProps<typeof Icon>['name']; text: string; value: boolean }>;
}) => {
  const { theme } = useTheme();
  return (
    <View
      style={{
        backgroundColor: 'white',
        borderRadius: 10,
        paddingVertical: 5,
        borderWidth: 1,
        borderBottomWidth: 2,
        borderColor: theme.color.dark,
      }}
    >
      {outcomes.map((outcome, i, arr) => (
        <Fragment key={outcome.text}>
          <View
            style={{ paddingHorizontal: 10, paddingVertical: 15, justifyContent: 'space-between' }}
            row
          >
            <View row style={{ gap: 10 }}>
              <Icon name={outcome.icon} size={16} color={theme.color.gray400} />
              <Label text={outcome.text} />
            </View>
            <View
              style={[
                {
                  borderWidth: 1,
                  borderRadius: 20,
                  width: 25,
                  height: 25,
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderColor: theme.color.gray500,
                },
                outcome.value
                  ? { borderColor: theme.color.accent100, backgroundColor: theme.color.accent100 }
                  : null,
              ]}
            >
              <Icon name="check" color="white" size={12} />
            </View>
          </View>
          {i < arr.length - 1 ? (
            <View style={{ width: '100%', height: 1, backgroundColor: theme.color.gray700 }} />
          ) : null}
        </Fragment>
      ))}
    </View>
  );
};
